"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _commission = require("@/api/commission.js");
var _dictionary = require("@/config/dictionary");
var _index = _interopRequireDefault(require("@/views/caseConditions/index.vue"));
var _index2 = require("@/utils/index.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'handing',
  data: function data() {
    var _ref;
    return _ref = {
      tableHeaderColor: this.$tableHeaderColor,
      pageSizes: this.$tablePageSizes,
      currentPage: 1,
      pageLimit: 10,
      //每页请求多少个数据，默认10
      total: 0,
      loading: true,
      tableData: [],
      conditionData: '',
      //来自子组件的数据
      date: '',
      caseState: _dictionary.dictionary.caseState,
      multipleSelection: [],
      multipleSelectionId: [],
      caseId: '',
      selectSecVisble: false,
      selectSecform: {
        secretaryId: ''
      },
      selectSecRules: {
        secretaryId: [{
          required: true,
          message: '请选择',
          trigger: 'change'
        }]
      }
    }, (0, _defineProperty2.default)(_ref, "caseState", _dictionary.dictionary.caseState), (0, _defineProperty2.default)(_ref, "secretaryList", []), _ref;
  },
  created: function created() {
    this.init();
  },
  components: {
    Caseconditons: _index.default
  },
  methods: {
    init: function init() {
      var _this = this;
      this.currentPage = 1;
      this.loading = true;
      (0, _commission.findUnAllotCasePage)({
        limit: this.pageLimit,
        page: 1
      }).then(function (res) {
        if (res.code == 1) {
          _this.tableData = res.rows;
          _this.total = res.total;
          _this.loading = false;
        }
      });
    },
    handleDetail: function handleDetail(val) {
      this.$router.push({
        name: 'inquiryDetail',
        params: {
          caseId: val
        }
      });
    },
    //自动分配秘书
    handleAutoAllot: function handleAutoAllot() {
      var _this2 = this;
      this.loading = true;
      (0, _commission.allotByWeight)().then(function (res) {
        if (res.code == 1) {
          _this2.$message({
            message: '设置成功',
            type: 'success'
          });
          _this2.init();
        } else {
          _this2.$message.error(res.msg);
        }
        _this2.loading = false;
      });
    },
    // 表格勾选事件
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //分配
    handleBatchAllot: function handleBatchAllot() {
      var _this3 = this;
      this.multipleSelectionId = [];
      this.multipleSelection.forEach(function (item) {
        _this3.multipleSelectionId.push(item.caseId);
      });
      this.selectSecVisble = true;
      (0, _commission.findSecretaryList)().then(function (res) {
        if (res.code == 1) {
          _this3.secretaryList = res.data;
        }
      });
    },
    handleSelectSecSubmit: function handleSelectSecSubmit(selectSecform) {
      var _this4 = this;
      this.$refs[selectSecform].validate(function (valid) {
        if (valid) {
          var params = {
            secretaryId: _this4.selectSecform.secretaryId,
            caseIds: _this4.multipleSelectionId
          };
          _this4.loading = true;
          (0, _commission.manualAllotCase)(params).then(function (res) {
            if (res.code == 1) {
              _this4.$message({
                message: '分配成功',
                type: 'success'
              });
              _this4.selectSecVisble = false;
              _this4.init();
            } else {
              _this4.$message.error(res.msg);
            }
            _this4.loading = false;
          });
        }
      });
    },
    //点击筛选，发送请求列表
    checkList: function checkList(data) {
      var _this5 = this;
      // 需要发送给后端的数据
      this.currentPage = 1;
      var postData = {
        caseId: data.caseId,
        caseNo: data.caseNo,
        partyName: data.partyName,
        defenceState: data.replyvalue,
        beginCtime: data.rowSecondDate[0],
        endCtime: data.rowSecondDate[1],
        caseType: data.caseTypevalue,
        beginRegisterTime: data.rowThirdDate[0],
        endRegisterTime: data.rowThirdDate[1],
        source: data.caseOriginvalue,
        limit: this.pageLimit,
        page: 1
      };
      this.conditionData = postData;
      (0, _commission.findUnAllotCasePage)(this.conditionData).then(function (res) {
        if (res.code == 1) {
          _this5.tableData = res.rows;
          _this5.total = res.total;
        }
      });
    },
    //点击 清空所有筛选条件
    cleanConditionData: function cleanConditionData() {
      this.conditionData = '';
      this.init();
    },
    // 分页事件
    handleSizeChange: function handleSizeChange(val) {
      var _this6 = this;
      this.pageLimit = val;
      if ((0, _index2.hasValueInObj)(this.conditionData)) {
        // 有筛选条件的情况下
        this.conditionData.limit = val;
        this.conditionData.page = this.currentPage;
        (0, _commission.findUnAllotCasePage)(this.conditionData).then(function (res) {
          if (res.code == 1) {
            _this6.tableData = res.rows;
            _this6.total = res.total;
          }
        });
      } else {
        //没有筛选条件的情况下
        (0, _commission.findUnAllotCasePage)({
          limit: val,
          page: this.currentPage
        }).then(function (res) {
          if (res.code == 1) {
            _this6.tableData = res.rows;
            _this6.total = res.total;
          }
        });
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      var _this7 = this;
      if ((0, _index2.hasValueInObj)(this.conditionData)) {
        // 有筛选条件的情况下
        this.conditionData.page = val;
        this.conditionData.limit = this.pageLimit;
        (0, _commission.findUnAllotCasePage)(this.conditionData).then(function (res) {
          if (res.code == 1) {
            _this7.tableData = res.rows;
            _this7.total = res.total;
            _this7.currentPage = val;
          }
        });
      } else {
        //没有筛选条件的情况下
        (0, _commission.findUnAllotCasePage)({
          limit: this.pageLimit,
          page: val
        }).then(function (res) {
          if (res.code == 1) {
            _this7.tableData = res.rows;
            _this7.total = res.total;
            _this7.currentPage = val;
          }
        });
      }
    }
  }
};
exports.default = _default;